<template>
  <div>
    <div style="margin-bottom: 20px;">
      <Button
        :label="t('Adicionar Atributo de Laudo')"
        icon="pi pi-plus"
        size="small"
        data-testid="so-report-attributes-add-btn"
        @click="handleNew"
      />
    </div>

    <!-- SOReportAttributes Table -->
    <s-o-report-attributes-table
      ref="soReportAttributesTableRef"
      @edit="handleEdit"
      @delete="handleDelete">
    </s-o-report-attributes-table>

    <!-- SOReportAttributesModal is centralized in ModalManager.vue - opened via eventBus -->
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { useI18n } from 'vue-i18n';
import { eventBus } from '../../eventBus';
import SOReportAttributesTable from './SOReportAttributesTable.vue';
import { log } from '../../utils/DebugLogger';

type Id = number | string;

interface Props {
  translations?: Record<string, unknown>;
}

interface DataTableInstance {
  loadData: () => void;
}

withDefaults(defineProps<Props>(), {
  translations: () => ({})
});

const { t } = useI18n();

const soReportAttributesTableRef = ref<DataTableInstance | null>(null);

const loadData = async (): Promise<void> => {
  log('SOReportAttributesPage', 'loadData', 'Reloading data');
  if (soReportAttributesTableRef.value) {
    await soReportAttributesTableRef.value.loadData();
  }
};

const handleNew = (): void => {
  log('SOReportAttributesPage', 'handleNew', 'Opening modal for new report attribute via eventBus');
  eventBus.emit('modal.so-report-attributes.open', { action: 'create' });
};

const handleEdit = (id: Id): void => {
  log('SOReportAttributesPage', 'handleEdit', 'Editing report attribute ID via eventBus', id);
  eventBus.emit('modal.so-report-attributes.open', { id, action: 'edit' });
};

const handleDelete = (id: Id, data: Record<string, unknown> | null = null): void => {
  log('SOReportAttributesPage', 'handleDelete', 'Deleting report attribute ID via eventBus', id);
  eventBus.emit('modal.so-report-attributes.open', { id, data, action: 'delete' });
};

const handleEditEvent = (id?: Id): void => { if (id !== undefined) handleEdit(id); };
const handleDeleteEvent = (id?: Id): void => { if (id !== undefined) handleDelete(id); };

onMounted(() => {
  log('SOReportAttributesPage', 'mounted', 'Component mounted');

  eventBus.on('so-report-attribute.new', handleNew);
  eventBus.on('so-report-attribute.edit', handleEditEvent);
  eventBus.on('so-report-attribute.delete', handleDeleteEvent);
});

onBeforeUnmount(() => {
  log('SOReportAttributesPage', 'beforeUnmount', 'Cleaning up event listeners');

  eventBus.off('so-report-attribute.new', handleNew);
  eventBus.off('so-report-attribute.edit', handleEditEvent);
  eventBus.off('so-report-attribute.delete', handleDeleteEvent);
});

defineExpose({
  loadData,
  handleNew,
  handleEdit,
  handleDelete
});
</script>

<style scoped>
</style>
